const thumbnails = document.querySelectorAll('.thumbnails img');
const videoPlayer = document.getElementById('video-player');
const headline = document.querySelector('.headline1');

// Unmute the video when the 'play' event is fired
videoPlayer && videoPlayer.addEventListener('play', function () {
  videoPlayer.muted = false;
});

thumbnails.forEach(thumbnail => {
  thumbnail.addEventListener('click', function () {
    const videoSrc = thumbnail.getAttribute('data-video');
    const videoHeadline = thumbnail.getAttribute('data-headline');

    videoPlayer.src = videoSrc;
    videoPlayer.play();  // Autoplay the video
    headline.textContent = videoHeadline;

    thumbnails.forEach(thumb => {
      thumb.classList.remove('highlight');
    });

    thumbnail.classList.add('highlight');
  });
});

$('.up-pro-slider').slick({
  dots: true,
  arrows: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        adaptiveHeight: true,
      }
    },

  ]
});

$('.up-pro-slide:only-child').parents('.up-pro-slider').addClass('one-slide');

$('.back-menu.sub-menu').click(function () {
  $(this).parents('li.side-menu-click').find('h3.submenubtn').click();
});
$('.back-menu.child-menu').click(function () {
  $(this).parents('li.slide-menu-childclick').find('h3.childmenu-btn').click();
});

$('button[aria-controls="sidebar-menu"]').click(function () {
  $('h3.childmenu-btn.active + div .back-menu.child-menu').click();
  $('h3.submenubtn.active + div .back-menu.sub-menu').click();
});

$('.custom-video-list-slider').slick({
  slidesToShow: 4,
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg fill="#000000" height="40px" width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.006 512.006" xml:space="preserve"><g><g><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0 L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251 c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></g></g></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg fill="#000000" height="40px" width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M388.418,240.915L153.752,6.248c-8.331-8.331-21.839-8.331-30.17,0c-8.331,8.331-8.331,21.839,0,30.17L343.163,256	L123.582,475.582c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0l234.667-234.667	C396.749,262.754,396.749,249.246,388.418,240.915z"/></g></g></svg></button>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1
      }
    }
  ]
})

$('.logobar_slider').slick({
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: true,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  infinite: true,
  initialSlide: 1,
  arrows: false,
  buttons: false
});










